import { CircularProgress, DialogContent } from "@mui/material";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { t } from "../../translations";

/**
 * Reusable Address Dialog Form Component
 * Used for adding/editing delivery addresses in dialogs
 */
const AddressDialogForm = ({
  titleKey,
  descriptionKey,
  buttonTextKey,
  address,
  setAddress,
  handleConvert,
  onSubmit,
  loading = false,
  lang,
  containerStyle = { minWidth: 300, height: "100%" }
}) => {
  const formFields = [
    {
      placeholder: t("common.enter_receiver_name", lang),
      name: "receiver_name",
      type: "input",
      type_input: "text",
      value: address?.receiver_name,
      onChange: (e) =>
        setAddress({
          ...address,
          receiver_name: e.target.value
        })
    },
    {
      placeholder: t("common.enter_phone_number", lang),
      name: "phone_number",
      type: "input",
      type_input: "number",
      value: address?.phone_number,
      onChange: (e) =>
        setAddress({
          ...address,
          phone_number: e.target.value
        })
    },
    {
      placeholder: t("common.enter_your_street_name", lang),
      name: "street_name",
      type: "input",
      type_input: "text",
      value: address?.street_name,
      onChange: async (text) => {
        await handleConvert(text);
      }
    },
    {
      placeholder: t("common.enter_your_line_address", lang),
      name: "line_address",
      type: "input",
      type_input: "text",
      value: address?.line_address,
      onChange: (e) =>
        setAddress({
          ...address,
          line_address: e.target.value
        })
    },
    {
      placeholder: t("common.enter_delivery_instruction", lang),
      name: "instruction",
      type: "input",
      type_input: "text",
      value: address?.instruction,
      onChange: (e) =>
        setAddress({
          ...address,
          instruction: e.target.value
        })
    }
  ];

  return (
    <DialogContent>
      <div style={containerStyle}>
        <div>
          <p
            style={{
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              gap: 15,
              fontWeight: 600,
              marginTop: 30,
              fontSize: 17
            }}
          >
            {t(titleKey, lang)}
          </p>
          <p
            style={{
              textAlign: "left",
              fontSize: 15
            }}
          >
            {t(descriptionKey, lang)}
          </p>
          <div className="section-chef-menu-right-address-inside-box">
            {formFields.map((item, index) => (
              <div
                key={`${item.name}-${index}`}
                onClick={() => {}}
                style={{
                  width: "100%"
                }}
              >
                {item?.type === "input" && item?.name !== "street_name" && (
                  <input
                    style={{
                      height: 40
                    }}
                    className="select-address-box"
                    placeholder={item?.placeholder}
                    name={item?.name}
                    value={item?.value || ""}
                    type={item?.type_input}
                    onChange={(e) => {
                      item?.onChange(e);
                    }}
                  />
                )}
                {item?.name === "street_name" && (
                  <GooglePlacesAutocomplete
                    apiKey={process.env.REACT_APP_API_KEY_MAP}
                    selectProps={{
                      onChange: (e) => {
                        item?.onChange(e?.label);
                      },
                      styles: {
                        container: (provided) => ({
                          ...provided,
                          marginTop: 20
                        }),
                        input: (provided) => ({
                          ...provided
                        }),
                        option: (provided) => ({
                          ...provided
                        })
                      },
                      placeholder: item?.placeholder
                    }}
                    apiOptions={{ language: "fr" }}
                    autocompletionRequest={{}}
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        <div
          className="btn-get-started"
          style={{
            backgroundColor: "#ff114d",
            width: "100%"
          }}
          onClick={() => {
            if (loading) {
              return;
            }
            return onSubmit();
          }}
        >
          {!loading && t(buttonTextKey, lang)}
          {loading && <CircularProgress size={25} />}
        </div>
      </div>
    </DialogContent>
  );
};

export default AddressDialogForm;
